var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-number d-flex flex-column justify-content-center align-center"},[_c('div',{staticClass:"stat-value"},[_vm._t("default"),_vm._t("stat")],2),_c('div',{staticClass:"stat-label subtext"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }